import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47e18414"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "supervision-banner",
  role: "status"
}

import { computed } from 'vue';
import { IonButton } from '@ionic/vue';
import userAuth from '@/composables/userAuth';


export default /*#__PURE__*/_defineComponent({
  __name: 'SupervisionBanner',
  setup(__props) {

const meta = computed(() => {
  const raw = localStorage.getItem('supervision');
  if (!raw) return null;
  try {
    return JSON.parse(raw) as { supervisor_name?: string };
  } catch {
    return null;
  }
});

const currentUserName = computed(() => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    return user?.name || 'usuario';
  } catch {
    return 'usuario';
  }
});

function exit(): void {
  userAuth().logout();
}

return (_ctx: any,_cache: any) => {
  return (meta.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", null, [
          _createTextVNode(" Modo supervisión: estás viendo la app como "),
          _createElementVNode("strong", null, _toDisplayString(currentUserName.value), 1),
          _createTextVNode(" (supervisor: " + _toDisplayString(meta.value.supervisor_name) + ") ", 1)
        ]),
        _createVNode(_unref(IonButton), {
          size: "small",
          fill: "solid",
          color: "light",
          onClick: exit
        }, {
          default: _withCtx(() => [
            _createTextVNode("Salir")
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})